import script from "./ProjectAnalysis.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectAnalysis.vue?vue&type=script&setup=true&lang=js"

import "./ProjectAnalysis.vue?vue&type=style&index=0&id=2fa1818c&lang=scss&scoped=true"

import exportComponent from "H:\\project\\tako\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2fa1818c"]])

export default __exports__